export const productName = 'OIL & GAS INDUSTRY TEACHER READY';
export const productShortName = 'Oil & Gas Industry Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/poKoUqSwugWBAuUJ77SdKM/mockup.png';

export const checkoutUrl = 'https://oil-gas-industry-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Oil & Gas Industry Fundamentals',
  'Volume 2 — Petroleum Geology, Reservoirs & Exploration',
  'Volume 3 — Drilling & Well Construction',
  'Volume 4 — Oil & Gas Production Operations',
  'Volume 5 — Oil Refining, Natural Gas Processing & Petroleum Products',
  'Volume 6 — Midstream Operations, Pipelines, Storage & Transportation',
  'Volume 7 — Oil & Gas Safety, Risk & Environmental Management',
  'Volume 8 — Oil & Gas Economics, Global Markets & Energy Transition',
  'Volume 9 — Teaching the Oil & Gas Industry',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Oil & Gas Assessment Bank',
  'Bonus 3 — 100 Case Studies & Industry Scenarios',
  'Bonus 4 — 50 Oil & Gas Classroom Projects & Challenges',
  "Bonus 5 — Oil & Gas Teacher's Dictionary: 200 Essential Concepts",
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex Oil & Gas concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see Oil & Gas's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
